import React from "react"
import Modal from "aldoo-ra/Modal"
import Button from "aldoo-ra/Button"

const SupportDialog = ({ isOpen, onClose, onContinue, texts }) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      variant="centered"
      className="md:max-w-md"
      closeOnEscape={true}
      title={texts?.supportTitle}
    >
      <div className="flex flex-col gap-5">
        <p className="text-sm text-text_secondary mt-0 mb-2">
          {texts?.supportSubtitle}
        </p>

        <div className="flex flex-col gap-3">
          <Button
            variant="primary"
            onClick={() => window.open("/contact", "_blank")}
            className="w-full"
          >
            {texts?.contactSupport}
          </Button>

          <Button variant="secondary" onClick={onContinue} className="w-full">
            {texts?.continueCancel}
          </Button>
        </div>
      </div>
    </Modal>
  )
}

export default SupportDialog
